<template>
    <div class="card">
        <div class="card-body">
            <h2>New Customers per Month</h2>
            <p v-if="!loaded">
                Loading...
            </p>
            <div id="customers-chart" />
        </div>
    </div>
</template>
<script>
import ApexCharts from 'apexcharts';
import ChartsService from '../../../services/ChartsService';

export default {
    data() {
        return {
            customersData: null,
            chart: null,
            options: {
                chart: {
                    type: 'line'
                },
                stroke: {
                    curve: 'smooth'
                },
                fill: {
                    type: 'solid',
                    opacity: [0.35, 1]
                }
            },
            loaded: false
        };
    },

    mounted() {
        ChartsService.customers().then(res => {
            this.customersData = res.data;
            const lastYear = this.customersData.slice(0, 12);
            const thisYear = this.customersData.slice(12);

            this.options.series = [
                {
                    name: 'This Year',
                    data: thisYear.map(data => data.count),
                    type: 'area'
                },
                {
                    name: 'Last Year',
                    data: lastYear.map(data => data.count)
                }
            ];
            this.options.xaxis = {
                categories: lastYear.map(data =>
                    window
                        .moment()
                        .month(parseInt(data.date.substring(5)) - 1)
                        .format('MMM')
                )
            };
            this.chart = new ApexCharts(
                document.getElementById('customers-chart'),
                this.options
            );
            this.loaded = true;
            this.chart.render();
        });
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/widgets/CustomersChartComponent.vue